import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';
import { authSelectors } from 'redux/auth';

// Unadvertised: /register-evp and /register?product= pick a new workspace's product; without either the server picks
export const useRegistrationProduct = () => {

  const [product] = useQueryParam('product', StringParam);

  const evpRoute = useRouteMatch('/register-evp');

  return product || (evpRoute ? 'evp' : undefined);
};

const useProduct = () => {

  // The last workspace stays in the store after logout
  const workspaceType = useSelector(state => (authSelectors.getUserIsLoggedIn(state) ? authSelectors.getWorkspace(state)?.type : undefined));

  const registrationProduct = useRegistrationProduct();

  return workspaceType ?? registrationProduct;
};

export default useProduct;
